import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'form-select-option',
  templateUrl: './select-option.component.html'
})
export class SelectOptionComponent implements OnInit {
  @Input() value: any;
  @Input() disabled: boolean;
  @Input() selected: boolean;

  constructor() { }

  ngOnInit() {
  }

}
